module.exports = __webpack_public_path__ + "img/2.aa7809b0.jpg";